import { TDeviceResponseType, TProductType, TSubscriptionType } from 'typings';

export function getPlanDetails(
  planLevel: number,
  subscriptionCycle: number
): string {
  // Determine the plan type based on the subscription cycle
  let planType: string;
  if (subscriptionCycle === 1) {
    planType = 'monthly';
  } else if (subscriptionCycle === 12) {
    planType = 'yearly';
  } else {
    planType = '';
  }
  return `${planType}_${planLevel}`;
}

export function getProductTypeFromDevice({
  deviceId,
  devices
}: {
  devices: TDeviceResponseType[];
  deviceId: string;
}): TProductType {
  return (
    devices.find((device) => device.id === deviceId)?.model_product_type ||
    'HomeSecurity'
  );
}

export function getProductTypeFromSubscription({
  subscriptions,
  subscriptionId
}: {
  subscriptions: TSubscriptionType[];
  subscriptionId: string;
}): string {
  return (
    subscriptions.find((subscription) => subscription.id === subscriptionId)
      ?.product_id || 'HomeSecurity'
  );
}

export function getAllDevicesByProductType(
  devices: TDeviceResponseType[],
  productType: TProductType
): TDeviceResponseType[] {
  return devices.filter((device) => device.model_product_type === productType);
}

export function getAllSubscriptionsByProductType(
  subscriptions: TSubscriptionType[],
  productType: TProductType
): TSubscriptionType[] {
  return subscriptions.filter(
    (subscription) => subscription.product_id === productType
  );
}
